import { toolStats } from "@/mocks/gossip";

export default function LiveBar() {
  return (
    <section className="border-y border-background-200 bg-background-50">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-4 px-4 py-5 md:px-6 md:flex-row md:items-center md:justify-between md:gap-6">
        <div className="flex items-center gap-2">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-foreground-950 text-background-50">
            <i className="ri-radar-fill text-lg" />
          </span>
          <div>
            <p className="text-sm font-extrabold text-foreground-950">今日首发雷达</p>
            <p className="text-xs text-foreground-700">
              实时滚动吃瓜91第一线首发量 · <span className="num font-semibold text-primary-600">今日 12:00</span> 前统计口径
            </p>
          </div>
        </div>

        <div className="grid flex-1 grid-cols-2 gap-3 sm:grid-cols-4 md:flex md:items-stretch md:justify-between">
          {toolStats.map((s) => (
            <div
              key={s.key}
              className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 px-4 py-3"
            >
              <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className={`${s.icon} text-lg`} />
              </span>
              <div className="flex flex-col">
                <span className="num text-xl font-black leading-none text-foreground-950">{s.value}</span>
                <span className="mt-1 text-[11px] font-semibold text-foreground-700">{s.label}</span>
              </div>
            </div>
          ))}
        </div>

        <a
          href="#feed"
          className="inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-5 py-3 text-sm font-bold text-background-50 transition hover:bg-primary-600"
        >
          <i className="ri-refresh-line text-base" /> 刷新滚一屏
        </a>
      </div>
    </section>
  );
}